var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      ref: "calculate-mortgage",
      attrs: {
        name: "calculate-mortgage",
        "extra-class": "full-screen-modal calculate-mortgage-modal",
        title: _vm.lang.labels.calculate_mortgage
      }
    },
    [
      _c("template", { slot: "body" }, [
        _vm.lang.mortgage.logo
          ? _c("img", {
              staticClass: "mortgage-logo",
              attrs: {
                src: _vm.lang.mortgage.logo,
                alt: _vm.lang.mortgage.logo_title
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "calculate-mortgage-container" }, [
          _vm.options.rate_visible
            ? _c("div", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.lang.labels.mortgage_rate) +
                    ": " +
                    _vm._s(
                      this.durations[
                        !this.options.fixed_rate ? this.local_duration : 0
                      ].TASSO__FIN
                    ) +
                    " %\n            "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form" },
            [
              _vm.options.user
                ? _c("my-multiselect", {
                    attrs: {
                      options: _vm.formattedUser,
                      "allow-empty": false,
                      placeholder: _vm.trans("labels.user"),
                      name: _vm.trans("labels.user"),
                      label: "name",
                      "track-by": "id"
                    },
                    on: { input: _vm.changeUser },
                    model: {
                      value: _vm.user,
                      callback: function($$v) {
                        _vm.user = $$v
                      },
                      expression: "user"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("my-input", {
                attrs: {
                  name: "price",
                  type: "text",
                  disabled: "",
                  label: _vm.lang.labels.estate_price
                },
                scopedSlots: _vm._u([
                  {
                    key: "append",
                    fn: function() {
                      return [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.lang.labels.currency) +
                            "\n                    "
                        )
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.formatted_price,
                  callback: function($$v) {
                    _vm.formatted_price = $$v
                  },
                  expression: "formatted_price"
                }
              }),
              _vm._v(" "),
              _c("my-input", {
                attrs: {
                  name: "mortgage",
                  type: "text",
                  disabled: _vm.options.user ? true : false,
                  label: _vm.lang.labels.estate_mortgage
                },
                on: { input: _vm.changeMortgage },
                scopedSlots: _vm._u([
                  {
                    key: "append",
                    fn: function() {
                      return [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.lang.labels.currency) +
                            "\n                    "
                        )
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.local_mortgage,
                  callback: function($$v) {
                    _vm.local_mortgage = $$v
                  },
                  expression: "local_mortgage"
                }
              }),
              _vm._v(" "),
              _c("my-multiselect", {
                attrs: {
                  options: _vm.formattedDurations,
                  "allow-empty": false,
                  placeholder: _vm.trans("labels.mortgage_duration"),
                  name: _vm.trans("labels.mortgage_duration"),
                  label: "name",
                  "track-by": "id"
                },
                on: {
                  input: function($event) {
                    _vm.local_duration = _vm.duration_object
                  }
                },
                model: {
                  value: _vm.duration_object,
                  callback: function($$v) {
                    _vm.duration_object = $$v
                  },
                  expression: "duration_object"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart" },
            [
              _c("div", { staticClass: "chart-upper-legend" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.lang.labels.mortgage_advantage)
                ),
                _c("br"),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.formatted_mortage_advantage) +
                    " " +
                    _vm._s(_vm.lang.labels.currency)
                ),
                _c("br"),
                _vm._v(
                  "\n                    (" +
                    _vm._s(_vm.advantage_percent) +
                    " %)\n                "
                )
              ]),
              _vm._v(" "),
              _c("donut", {
                attrs: {
                  percent: 100 - _vm.advantage_percent,
                  "background-color": "#50bf77",
                  "foreground-color": "#148240",
                  "stroke-width": 25,
                  radius: 60
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "chart-lower-legend" }, [
                _vm._v(
                  "\n                    " + _vm._s(_vm.lang.labels.mortgage)
                ),
                _c("br"),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.local_mortgage) +
                    " " +
                    _vm._s(_vm.lang.labels.currency)
                ),
                _c("br"),
                _vm._v(
                  "\n                    (" +
                    _vm._s(100 - _vm.advantage_percent) +
                    " %)\n                "
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.options.payment_type && _vm.options.payment_type.length > 1
            ? _c("div", { staticClass: "results" }, [
                _c("div", { staticClass: "payment" }, [
                  _c("div", { staticClass: "elements" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.payment_type,
                          expression: "payment_type"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        id: "input-payment-type-fixed",
                        name: "payment-type",
                        value: "TF",
                        type: "radio"
                      },
                      domProps: { checked: _vm._q(_vm.payment_type, "TF") },
                      on: {
                        change: function($event) {
                          _vm.payment_type = "TF"
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "input-payment-type-fixed" }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.lang.labels.fixed_payment) +
                            ":\n                        "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.fixed_payment) +
                        " " +
                        _vm._s(_vm.lang.labels.currency) +
                        "\n                    "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "payment" }, [
                  _c("div", { staticClass: "elements" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.payment_type,
                          expression: "payment_type"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        id: "input-payment-type-variable",
                        name: "payment-type",
                        value: "TV",
                        type: "radio"
                      },
                      domProps: { checked: _vm._q(_vm.payment_type, "TV") },
                      on: {
                        change: function($event) {
                          _vm.payment_type = "TV"
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "input-payment-type-variable" }
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.lang.labels.variable_payment) +
                            ":\n                        "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.variable_payment) +
                        " " +
                        _vm._s(_vm.lang.labels.currency) +
                        "\n                    "
                    )
                  ])
                ])
              ])
            : _c("div", [
                _c("strong", [_vm._v(_vm._s(_vm.lang.labels.mortgage_result))]),
                _vm._v(
                  ": " +
                    _vm._s(_vm.fixed_payment) +
                    " " +
                    _vm._s(_vm.lang.labels.currency) +
                    "\n            "
                )
              ]),
          _vm._v(" "),
          _vm.options.external
            ? _c("div", { staticClass: "actions" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-network",
                    attrs: { href: _vm.mortgageLink, target: "_blank" }
                  },
                  [_vm._v(_vm._s(_vm.lang.labels.mortgage_advice))]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "text-center m-2" })
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }